import { defineStore } from "pinia";
import axios from "axios";
import { useLoadingStore } from "@/stores/loadingStore";

export const usePartnerStore = defineStore("partnerStore", {
  state: () => ({
    partnerHeadline: "",
    partnerDescription: "",
    partners: [],
    isLoading: false,
    error: null,
  }),

  actions: {
    async fetchPartners() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get("/api/Partner/GetPartners");
        this.partners = response.data.Payload.Partners;
        this.partnerHeadline =
          response.data.Payload.PartnerSettings.partners_headline;
        this.partnerDescription =
          response.data.Payload.PartnerSettings.partners_description;
      } catch (error) {
        this.error = "Ortaklar alınırken bir hata oluştu";
      } finally {
        this.isLoading = false;
        loadingStore.finishLoading();
      }
    },
  },
});
